export interface DashboardStore {
  StoreId: string;
  Code: string;
  Title: string;
}

export interface DashboardProduct {
  Code: string;
  Title: string;
}

export interface DashboardOffer {
  OfferCode: string;
  OfferTitle: string;
  DiscountPercentage: number;
  FixedPrice: number;
}

export interface ProductInPeriod {
  ProductCode: string | null;
  VAT: number;
  Units: number;
  TotalAmountPaid: number;
}

export interface OfferInPeriod {
  OfferCode: string;
  Units: number;
}

export interface PeriodTransaction {
  Year: number;
  Month?: number;
  Week?: number;
  Stores: string[];
  TotalAmountPaid: number;
  TotalAmountCash?: number;
  TransactionCount: number;
  CashTransactionCount?: number;
  ProductsInPeriod: ProductInPeriod[];
  OffersInPeriod?: OfferInPeriod[];
}

export interface TransactionProduct {
  ProductCode: string;
  PriceAfterDiscount: number;
  Units: number;
}

export interface Transaction {
  Id: number;
  StoreId: string;
  TransactionDate: string;
  AmountPaid: number;
  Products: TransactionProduct[];
  Offers: string[];
}

export interface DailyTransaction {
  Year: number;
  Month: number;
  Day: number;
  Stores: string[];
  TotalAmountPaid: number;
  TotalAmountCash: number;
  TransactionCount: number;
  CashTransactionCount?: number;
}

export interface TransactionsResponse {
  MonthlyTransactions: PeriodTransaction[];
  DailyTransactions: DailyTransaction[];
  Transactions: Transaction[];
}

export interface KPIData {
  totalIncome: number;
  totalSales: number;
  avgPerMonth: number;
  avgPerWeek: number;
  currentMonthIncome: number;
  currentWeekIncome: number;
  currentMonthVsAvg: number;
  currentWeekVsAvg: number;
  thisMonthIncomeGrowth: number;
  thisMonthSalesGrowth: number;
  todaySales: number;
  todayAmountPaid: number;
  todayAmountCash: number;
  avgItemsPerTransaction: number;
  lastMonthAvgItems: number;
  lastMonthAvgItemsVsAvg: number;
}

export interface StoreSelectOption {
  value: string;
  label: string;
}

export interface PerformanceThresholds {
  excellent: {
    minAvgRevenue: number;
    minProductsSold: number;
  };
  good: {
    minAvgRevenue: number;
    minProductsSold: number;
  };
  average: {
    minAvgRevenue: number;
    minProductsSold: number;
  };
}

export const DEFAULT_THRESHOLDS: PerformanceThresholds = {
  excellent: {
    minAvgRevenue: 10,
    minProductsSold: 100,
  },
  good: {
    minAvgRevenue: 7,
    minProductsSold: 50,
  },
  average: {
    minAvgRevenue: 5,
    minProductsSold: 25,
  },
};

// Chart.js dataset interfaces
export interface LineChartDataset {
  label: string;
  data: number[];
  fill?: boolean;
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
  tension: number;
  borderDash?: number[];
}

export interface LineChartData {
  labels: string[];
  datasets: LineChartDataset[];
}
